var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui segment credits-view"},[_c('h3',[_vm._v(_vm._s(_vm.t('user.edit.credit.title')))]),_vm._v(" "),_c('CUserCredit',{attrs:{"current_user":_vm.current_user}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }